import { LatLng } from "use-places-autocomplete";
import { FranchiseWithDistance } from "../../types";

export function sortFranchise(
  a: FranchiseWithDistance,
  b: FranchiseWithDistance
) {
  if (
    a.distanceFromLocationInMeters === undefined &&
    b.distanceFromLocationInMeters === undefined
  ) {
    // Both distances are undefined, sort by name
    return a.name.localeCompare(b.name);
  } else if (a.distanceFromLocationInMeters === undefined) {
    // Only 'a' is undefined, so 'b' comes first
    return 1;
  } else if (b.distanceFromLocationInMeters === undefined) {
    // Only 'b' is undefined, so 'a' comes first
    return -1;
  } else {
    // Neither are undefined, sort by distance
    return a.distanceFromLocationInMeters - b.distanceFromLocationInMeters;
  }
}

export function calculateDistanceBetweenTwoCoordinates(
  latLng1: LatLng,
  latLng2: LatLng
): number {
  const R = 6371e3; // Radius of the Earth in meters
  const phi1 = toRadians(latLng1.lat);
  const phi2 = toRadians(latLng2.lat);
  const deltaPhi = toRadians(latLng2.lat - latLng1.lat);
  const deltaLambda = toRadians(latLng2.lng - latLng1.lng);

  const a =
    Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) +
    Math.cos(phi1) *
      Math.cos(phi2) *
      Math.sin(deltaLambda / 2) *
      Math.sin(deltaLambda / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return (R * c) | 0; // Distance in meters
}
function toRadians(degrees: number): number {
  return (degrees * Math.PI) / 180;
}
